import { ApplicationController } from "../../application_controller"
import Rails from '@rails/ujs'
import SelectizePublicController from "../../layouts/helpers/selectize_public_controller"
import DaterangepickerPublicController from "../../layouts/helpers/daterangepicker_public_controller"

export default class extends ApplicationController {
    static targets = ["mainForm"]

    initialize() {}

    connect() {
	var selectize_public_controller = new SelectizePublicController()
	selectize_public_controller.create(this.element)
	var daterangepicker_public_controller = new DaterangepickerPublicController()
	daterangepicker_public_controller.create(this.element)

	this.element.querySelectorAll("form textarea").forEach(el => { this.textareaResize(el) })

	if (this.mainFormTarget.querySelector('.helper-affirm')) {
	    this.mainFormTarget.querySelector('input[type="submit"]').closest('.field').classList.add('affirm-incomplete')
	}

	this.affirmResendCodeConnectTimers()
    }

    disconnect() {
	var selectize_public_controller = new SelectizePublicController()
	selectize_public_controller.destroy(this.element)

	this.affirmResendCodeDisconnectTimers()
    }

    textareaResizer(event) {
	this.textareaResize(event.currentTarget)
    }

    textareaResize(element) {
	element.style.height = "auto"
	element.style.height = (element.scrollHeight + 2) + "px"
    }

    affirm(event) {
	var affirm_attributes = ["person_email", "person_phone"]
	var name_attribute = event.currentTarget.getAttribute("name").match(/\[(.*?)\]/)?.[1] ?? ""
	if (affirm_attributes.includes(name_attribute)) {
	    var form_element = this.mainFormTarget
	    var url = new URL(form_element.action)
	    url.searchParams.set('form_need_code', true)
	    form_element.action = url.href

	    if (name_attribute == "person_email") {
		var value = event.currentTarget.value
		value = value.replace(/\s+/g, "") // Remove spaces
		event.currentTarget.value = value
	    } else if (name_attribute == "person_phone") {
		var value = event.currentTarget.value
		value = value.replace(/\s+/g, "").replace(/\D/g, "") // Remove spaces & all non-digit characters
		event.currentTarget.value = value

		if (/^\d{10}$/.test(value)) {
		    Rails.fire(form_element, "submit")
		}
	    }

	    if (this.mainFormTarget.querySelector('.helper-affirm')) {
		this.mainFormTarget.querySelector('.helper-affirm').remove()
		this.mainFormTarget.querySelector('input[type="submit"]').closest('.field').classList.remove('affirm-incomplete')
	    }
	}
    }

    affirmInput(e) {
	const value = e.currentTarget.value
	const inputs = e.currentTarget.parentNode.children
	const index = Array.from(e.currentTarget.parentNode.children).indexOf(e.currentTarget)

	// Only allow digits
	if (!/^\d$/.test(value)) {
	    e.currentTarget.value = ""
	    return
	}

	// Move to next input if exists
	if (index < inputs.length - 1) {
	    inputs[index + 1].focus()
	}

	var valueFieldElement = e.currentTarget.closest(".helper-affirm-field").querySelector("input[type='hidden']")
	valueFieldElement.value = Array.from(inputs).map(i => i.value).join("")
	valueFieldElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    affirmKeydown(e) {
	const inputs = e.currentTarget.parentNode.children
	const index = Array.from(e.currentTarget.parentNode.children).indexOf(e.currentTarget)

	// Handle backspace
	if (e.key === "Backspace" && e.target.value === "" && index > 0) {
	    inputs[index - 1].focus()
	}

	var valueFieldElement = e.currentTarget.closest(".helper-affirm-field").querySelector("input[type='hidden']")
	valueFieldElement.value = Array.from(inputs).map(i => i.value).join("")
	valueFieldElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    affirmPaste(e) {
	e.preventDefault()

	const inputs = e.currentTarget.parentNode.children
	const paste = (e.clipboardData || window.clipboardData).getData("text")
	const digits = paste.replace(/\D/g, "").slice(0, inputs.length) // keep only digits, max 6

	digits.split("").forEach((digit, i) => {
	    inputs[i].value = digit
	    inputs[i].dispatchEvent(new Event('input', { bubbles: true }))
	})

	// Focus the last filled input
	const lastIndex = Math.min(digits.length, inputs.length) - 1
	inputs[lastIndex].focus()
    }

    affirmResendCodeConnectTimers() {
	var btnElements = this.mainFormTarget.querySelectorAll('.helper-affirm .helper-affirm-button')
	this.timers = this.timers || []

	btnElements.forEach((el, i) => {
	    if (this.timers[i]) { clearInterval(this.timers[i]) }

	    var match = el.textContent.match(/\d+/)
	    let timeLeft = match ? parseInt(match[0], 10) : 0

	    // Fallback if no number found
	    if (timeLeft <= 0) timeLeft = 60

	    el.classList.remove("active")

	    this.timers[i] = setInterval(() => {
		timeLeft--

		if (timeLeft > 0) {
		    el.textContent = `Resend Code in ${timeLeft}s`
		} else {
		    clearInterval(this.timers[i])
		    el.textContent = "Resend Code"
		    el.closest(".helper-affirm").querySelector(".helper-affirm-message").remove()
		    el.classList.add("active")
		}
	    }, 1000)
	})
    }

    affirmResendCodeDisconnectTimers() {
	if (this.timers) {
	    this.timers.forEach(timer => clearInterval(timer))
	    this.timers = []
	}
    }

    affirmResendCode(event) {
	event.preventDefault()
	var form_element = this.mainFormTarget
	var url = new URL(form_element.action)
	url.searchParams.set('form_need_code', true)
	form_element.action = url.href
	Rails.fire(form_element, "submit")
    }

    affirmComplete(event) {
	var affirm_attributes = ["person_email_affirm", "person_phone_affirm"]
	var name_attribute = event.currentTarget.getAttribute("name").match(/\[(.*?)\]/)?.[1] ?? ""
	if (affirm_attributes.includes(name_attribute)) {
	    if (name_attribute == "person_email_affirm" || name_attribute == "person_phone_affirm") {
		var codeRegex = /^\d{6}$/ // 6 digits
		var value = event.currentTarget.value
		value = value.replace(/\s+/g, "").replace(/\D/g, "") // Remove spaces & all non-digit characters
		event.currentTarget.value = value

		if (codeRegex.test(value)) {
		    var form_element = this.mainFormTarget
		    var url = new URL(form_element.action)
		    url.searchParams.set('form_need_affirm', true)
		    form_element.action = url.href
		    Rails.fire(form_element, "submit")
		}
	    }
	}
    }
}
